


<div class="page-header col-md-12 p-3" >
    <div class="row">
        <div class="col-md-6">
            <h3 class="page-title" translate>User<h5 translate> Manage User Accounts</h5></h3>
            <ol class="breadcrumb bg-white p-0">
               
                <li class="breadcrumb-item active " aria-current="page">Settings / User Administration</li>
            </ol>
        </div>
        <div ngbDropdown class="  col-md-6 d-flex   justify-content-md-end align-items-center">
        
            <a (click)="backClicked()" ngbTooltip="Download"  class="btn btn-warning btn-sm btn-icon mr-2">
                <span>
                    <i class="fa-solid fa-circle-chevron-left "><span class="ms-1">BACK</span></i>
                </span>
            </a>
            <a routerLink="/register" routerLinkActive="blue" translate ngbTooltip="Add User" class="btn btn-info btn-sm btn-icon  mr-2">
                <span>
                    <i class="fa fa-plus"><span class="ml-1"  translate> Add User</span></i>
                </span> 
            </a>
            <!--<a ngbDropdownToggle href="javascript:void(0);" class="btn btn-secondary dropdown-toggle btn-sm me-2">
                <span >
                    <i class="fe fe-external-link"></i> Export <span class="caret"></span>
                </span >
                <div ngbDropdownMenu class="dropdown-menu" role="menu" >
                <a ngbDropdownItem href="javascript:void(0);" class="dropdown-item"><i class="bx bxs-file-pdf me-2"></i>Export as
                    Pdf</a>
                <a ngbDropdownItem href="javascript:void(0);" class="dropdown-item"><i class="bx bxs-file-image me-2"></i>Export as
                    Image</a>
                <a ngbDropdownItem href="javascript:void(0);" class="dropdown-item"><i class="bx bxs-file me-2"></i>Export as
                    Excel</a>
            </div>
            </a>-->
        </div>
    </div>

</div>


<!-- Content Header (Page header) -->
<!--<section class="content-header mt-4">
	<div class="d-flex justify-content-between pt-1 align-items-center">
		<h3 translate>Users<h5 translate> Manage User Accounts</h5>
		</h3>
	
		<div>
			<a class="btn btn-dark btn-sm " *ngIf="perms===true"
				routerLink="/register" routerLinkActive="blue" translate><i class="fa fa-user pr-2"></i>REGISTER A NEW USER</a>
		
		</div>
		

	</div>
</section>-->





<div class="box box-primary rounded border-top border-primary shadow-lg bg-white">






    <div class=" row flex-row justify-content-around  m-1"  >
        <div class="flex-column col-sm-3 box box-primary  border-top border-primary shadow-sm bg-white   p-3"
            style="max-width:100%; min-width: 20%; font-family:Trebuchet MS; "  >
           
                <h4 class="w-100 bg-success text-light p-2"><strong translate>Sales Representative</strong></h4>
            <h1 class="text-success" ><i class="fa fa-users "></i></h1><label class="w-100" translate>Read Only</label> 
                <h1 class="float-right ">{{mississuagaCount}}</h1>

        </div>

        <div class="flex-column col-sm-3 box box-primary border-top border-primary shadow-sm bg-white p-3 "
            style="max-width:100%; min-width: 20%; font-family:Trebuchet MS; " >
            
            <h4  class="w-100 bg-primary text-light p-2" ><strong translate>Administrator</strong></h4>
            <h1 class="text-primary" ><i class="fa fa-user-shield "></i> </h1><label class="w-100" translate>Full Access with limitation</label> 
            <h1 class="float-right ">{{lawrenceCount}}</h1>

        </div>

        <div class="flex-column  col-sm-3 box box-primary border-top  border-primary shadow-sm bg-white   p-3 "
            style="max-width:100%; min-width: 20%; font-family:Trebuchet MS;">
            <h4 class="w-100 bg-danger text-light p-2"><strong translate>System Admin</strong></h4>
            <h1 class="text-danger" ><i class="fa fa-user-secret "></i> </h1><label class="w-100" translate> Full Access to Everything</label> 
                <h1 class="float-right ">{{vaughanCount}}</h1>

        </div>


        <div class="flex-column  col-sm-3 box box-primary border-top  border-primary shadow-sm bg-white   p-3 "
        style="max-width:100%; min-width: 20%; font-family:Trebuchet MS;">
        <h4 class="w-100  text-light p-2" style="background-color: #634025;"><strong translate>Power User</strong></h4>
        <h1 class="" style="color: #634025;" ><i class="fa fa-user-tie "></i> </h1><label class="w-100" translate>Partial Access</label> 
            <h1 class="float-right ">{{torontoCount}}</h1>

    </div>
    </div>



    

   <!-- <div class=" row flex-row justify-content-around  m-1"  >
        <div class="flex-column flex-column col-sm-3 box box-primary  border-top border-primary shadow-sm bg-white   p-3"
            style="max-width:100%; min-width: 20%; font-family:Trebuchet MS; ">
           
            <h4 class="w-100  text-light p-2" style="background-color: #0b0c4a;"><strong>Agency</strong></h4>
            <h1  style="color: #0b0c4a;" ><i class="fa fa-user-friends"></i> </h1><label class="w-100">Partial Access</label> 

                <h1 class="float-right ">{{agencyCount}}</h1>

        </div>

        
        <div class="flex-column  col-sm-3 box box-primary border-top  border-primary shadow-sm bg-white   p-3 "
            style="max-width:100%; min-width: 20%; font-family:Trebuchet MS;">
            <h4 class="w-100  text-light p-2" style="background-color: #1d648c;"><strong>Team Lead</strong></h4>
            <h1 class="" style="color: #1d648c;" ><i class="fa fa-chalkboard-teacher "></i> </h1><label class="w-100">Department Access</label> 
                <h1 class="float-right ">{{teamleadCount}}</h1>

        </div>


        <div class="flex-column flex-column col-sm-3 box box-primary border-top border-primary shadow-sm bg-white p-3 "
            style="max-width:100%; min-width: 20%; font-family:Trebuchet MS; " >
            
            <h4 class="w-100  text-light p-2" style="background-color: #003157;"><strong>Tech Support</strong></h4>
            <h1 class="" style="color: #003157;" ><i class="fa fa-user-nurse "></i> </h1><label class="w-100"> Full Access with limitation</label>
            <h1 class="float-right ">{{techsupportCount}}</h1>

        </div>


        <div class="flex-column  col-sm-3 box box-primary border-top  border-primary shadow-sm bg-white   p-3 "
        style="max-width:100%; min-width: 20%; font-family:Trebuchet MS;">
        <h4 class="w-100  text-light p-2" style="background-color: #364d43;"><strong>Reporter</strong></h4>
        <h1 class="" style="color: #364d43;" ><i class="fa fa-user "></i> </h1><label class="w-100">Access to Reports only</label>
            <h1 class="float-right ">{{reporterCount}}</h1>

    </div>
    </div>
-->

    


<div class="col-lg-12 mb-3">
		
	
			<div class="card h-100">
				<div class="card-header d-flex justify-content-between">
				  <div>
				  <h6 class="card-title mt-2 mb-0 ">User/s</h6>
				  </div>
				  <div class="input-group w-50 ">
					  <input
						type="text"
						class="form-control"
						placeholder="Search"
						[(ngModel)]="searchText" 
					  />
					  <span>
						<button
						  class="btn  btn-primary rounded-start-0"
						  type="button"
						>
						 <i class="fa fa-search"></i>
						</button>
					  </span>
					</div>
			  
				</div>
	
				<div class="card-body">
					<div class="canvasd">
		<div class="table-responsive">
			<div class="asset-table " style="height: 1000px;">
				<table id="dataTablesFull" class="table table-striped table-hover">
					<thead>
						<tr>
							<th class="text-center" translate>User ID</th>
							<th style="padding-left: 100px;"translate>Name</th>
							<!--<th class="text-center" translate>Role</th>-->
							<th class="text-center" translate>Branch</th>
							<th class="text-center" translate>Status</th>
							<th class="text-center" translate>Action </th>
						</tr>
					</thead>


					<!--gets all the assets from assets table-->
					<tbody>

						<tr *ngFor='let users of allUsersWithColors | filter:searchText'>
							<td class="text-info text-center" *ngIf="perms==true; else elseBlock1 "
								(click)="viewUser(users)">
								{{users.userName }}
							</td>
							<ng-template #elseBlock1>
								<td class="text-center">{{users.userName}}</td>
							</ng-template>

							<td class="name-column"  (click)="viewUser(users)">
								<div class="name-container ">
								<span class="initials-circle"  [ngStyle]="{'background-color':   users.initialsColor}">
									{{ getInitials(users) }}
								</span>
								<div class="name-role-container">
									<div class="full-name">{{ users.firstName }} {{ users.middleName }} {{ users.lastName }}</div>
									<div class="role">{{ users.role }}</div>
									</div>
							</div>
							</td>
							<!--<td class="text-info text-center" *ngIf="perms==true; else elseBlock2 " (click)="viewUser(users)">
								{{users.firstName}} {{users.middleName}} {{users.lastName}}
							</td>
							<ng-template #elseBlock2>
								<td class="text-center">{{users.role}}</td>
							</ng-template>


							<td class="text-info text-center" (click)="viewUser(users)" *ngIf="perms; else elseBlock ">
								{{users.role}}
							</td>-->
							<ng-template #elseBlock>
								<td class="text-center">{{users.role}}</td>
							</ng-template>
							<td class="text-center" (click)="viewUser(users)">{{users.branch}}</td>
							<div class="text-center" [ngSwitch]="users.status" (click)="viewUser(users)">

								 <td class="badge bg-success text-light m-1 text-center" *ngSwitchCase="'yes'">
									{{users.status}}</td>
								<td class="badge bg-danger text-light m-1 text-center" *ngSwitchCase="'InActive'">
									{{users.status}}</td>
								<td class="badge bg-danger text-light m-1 text-center" *ngSwitchCase="'Discarded'">
									{{users.status}}</td>
								<td class="badge bg-warning text-light m-1 text-center"
									*ngSwitchCase="'Pending Approval'">
									{{users.status}}</td>
								<td class="badge bg-primary text-light m-1" *ngSwitchCase="'Active'">
									{{users.status}}</td>
								<td class="badge bg-warning text-light" *ngSwitchCase="'In Repair'">
									{{users.status}}</td>
								<td class="badge bg-danger text-light" *ngSwitchCase="'Broken'">{{users.status}}
								</td>
								<td class="badge bg-info text-light" *ngSwitchCase="'EWaste'">{{users.status}}
								</td>
							</div>


							<td class="text-center" *ngIf="perms==true; ">

								<i class="far fa-trash-alt border rounded mx-1 p-1 text-center" data-toggle="modal" data-target="#deleteModal" (click)='passDetailToModal(users)'></i>
								<i (click)='editUser(users)' class="far fa-edit  border rounded mx-1 p-1 text-center"></i>
							</td>




							<!---------- Delete Modal ------------------------------------------------------------------------------------------------------------>
							<div class="modal fade" id="deleteModal" tabindex="-1" role="dialog"
								aria-labelledby="deleteModalLabel" aria-hidden="true">
								<div class="modal-dialog" role="document">
									<div class="modal-content">
										<div class="modal-header">
											<h5 class="modal-title" id="deleteModalLabel">
												<strong translate>DELETE</strong></h5>
											<button type="button" class="close" data-dismiss="modal" aria-label="Close">
												<span aria-hidden="true">&times;</span>
											</button>
										</div>
										<div class="modal-body" translate>
											Are you you want to delete <br>
											<strong translate>ID :</strong> {{modalUser.userName}}<br>
											<strong translate>Name :</strong> {{modalUser.firstName}} {{modalUser.middleName}} {{modalUser.lastName}}<br>
											<strong translate>Role :</strong> {{modalUser.role}}
										</div>
										<div class="modal-footer">
											<button type="button" class="btn btn-secondary"
												data-dismiss="modal" translate>Close</button>
											<button type="button" (click)=actionDelete(modalUser);
												data-dismiss="modal" class="btn btn-primary">Delete</button>
										</div>
									</div>
								</div>
							</div>
							<!------------------------------------------------------------------------------------------------------------------------------------------>

						</tr>
					</tbody>

				</table>
			</div>
		</div>
	
	</div>
</div>
	</div>

	<!-----------Success Modal------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------>
<button id="openSuccessModalButton" [hidden]="true" data-toggle="modal" data-target="#SuccessModal">Open Modal</button>
<!-- Modal -->
<div id="SuccessModal" class="modal fade" role="dialog">
    <div class="modal-dialog">
  
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          
          <h4 class="modal-title text-success" translate>SUCCESS</h4>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body text-success">
          <p translate>User have been saved</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" (click)=refreshWindow(); data-dismiss="modal" translate>Close</button>
        </div>
      </div>
  
    </div>
  </div>


<!----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------->

<!-----------Erroe Modal------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------>
<button id="openErrorModalButton" [hidden]="true" data-toggle="modal" data-target="#ErrorModal">Open Modal</button>
<!-- Modal -->
<div id="ErrorModal" class="modal fade" role="dialog">
    <div class="modal-dialog">
  
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          
          <h4 class="modal-title text-danger" translate>ERROR</h4>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body text-danger">
          <p>{{error}}</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default"  data-dismiss="modal" translate>Close</button>
        </div>
      </div>
  
    </div>
  </div>
